module.exports = __webpack_public_path__ + "img/pop mart.2cadb04b.jpg";